import React from 'react';
import { Row, Col } from 'shards-react';
import TileComponent from '../TileComponent/TileComponent';

export const TilesComponent = ({ complaints }) => {
  let { open, closed, processing, overdue } = 0;
  open = complaints.filter((item) => item.status === 'open').length;
  closed = complaints.filter((item) => item.status === 'closed').length;
  processing = complaints.filter((item) => item.status === 'processing').length;
  overdue = complaints.filter((item) => item.status === 'overdue').length;

  return (
    <Row className='mb-3'>
      {open && open > 0 ? (
        <Col md='3' sm='6' className='mt-2'>
          <TileComponent type='open' title='Open' number={open} />
        </Col>
      ) : (
        ''
      )}
      {closed && closed > 0 ? (
        <Col md='3' sm='6' className='mt-2'>
          <TileComponent type='closed' title='Closed' number={closed} />
        </Col>
      ) : (
        ''
      )}
      {processing && processing > 0 ? (
        <Col md='3' sm='6' className='mt-2'>
          <TileComponent
            type='processing'
            title='Processing'
            number={processing}
          />
        </Col>
      ) : (
        ''
      )}
      {overdue && overdue > 0 ? (
        <Col md='3' sm='6' className='mt-2'>
          <TileComponent type='overdue' title='Overdue' number={overdue} />
        </Col>
      ) : (
        ''
      )}
    </Row>
  );
};
